<template>
  <div class="container card-item">
    <div class="card-title">
      <div class="title-box">
        <span class="title-text">品牌活动</span>
      </div>
      <div class="title-boxs">
        <span class="btn-action-group">
          <a-button
            type="primary"
            v-if="(oldInfos?.id && isRevise) || !isScore"
            @click="addActivitys"
            class="btn-action"
            >新增</a-button
          >
          <!-- <a-button
            class="btn-action"
            type="primary"
            v-if="oldInfos?.id"
            @click="showevidence"
          >
            佐证材料</a-button
          > -->
          <!-- <a-button
            @click="importsj()"
            class="btn-action"
            v-if="(oldInfos?.id && isRevise) || !isScore"
          >
            导入
          </a-button> -->
          <a-button
            class="btn-action"
            v-if="(oldInfos?.id && isRevise) || !isScore"
            danger
            type="text"
            @click="batchDelete"
          >
            批量移除</a-button
          >
        </span>
      </div>
    </div>

    <div class="containerfooter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :row-selection="rowSelection"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template slot="type" slot-scope="text, record">
          <span v-if="text == '其他'">{{ record.otherType }}</span>
          <span v-else>{{ text }}</span>
        </template>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 50px"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && !isEdit) || isScore"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && isRevise) || !isScore"
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && isRevise) || !isScore"
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && !isRevise) || isScore"
            @click="seeInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>查看</span>
          </div>
        </span>
      </a-table>
    </div>
    <add-activity ref="addActivity" @addActivity="addActivitycz"></add-activity>

    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除该条品牌活动吗?</p>
    </a-modal>
    <data-import ref="dataImport" @refreshData="addActivity"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :id="id"
          :dataid="sj.id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import evidencelist from "@/components/common/evidencelist";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "活动名称",
    dataIndex: "name",
    id: "name",
    align: "center",
    width: 150,
  },
  // {
  //   title: "年份",
  //   dataIndex: "activityYear",
  //   id: "activityYear",
  //   align: "center",
  //   width: 100,
  // },
  {
    title: "时间",
    dataIndex: "holdingTime",
    id: "holdingTime",
    align: "center",
    width: 150,
  },
  {
    title: "活动分类",
    dataIndex: "type",
    id: "type",
    align: "center",
    width: 150,
    scopedSlots: { customRender: "type" },
  },
  // {
  //   title: "活动数量",
  //   dataIndex: "num",
  //   id: "num",
  //   align: "center",
  //   width: 150,
  // },

  // {
  //   title: "活动举办时间",
  //   dataIndex: "holdingTime",
  //   id: "holdingTime",
  //   align: "center",
  //   width: 100,
  // },
  // {
  //   title: "参与人数",
  //   dataIndex: "partNum",
  //   id: "partNum",
  //   align: "center",
  //   width: 100,
  // },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 300,
    scopedSlots: { customRender: "action" },
  },
];
import addActivity from "./addActive.vue";
export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      isEdit: false,
      selectedRowKeys: [],
      emptyText: "暂无数据",
      showtable: false,
      id: "",
      title: "",
      sj: {},
      isScore: false,
    };
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isRevise: {
      type: Boolean,
    },
  },
  components: {
    addActivity,
    dataImport,
    evidencelist,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  watch: {
    "oldInfos.brandActivitylist": {
      handler(newValue, oldValue) {
        if (newValue != null) {
          this.emptyText = "暂无数据";
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.emptyText = "暂无数据";
          this.addActivity();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    isRevise: {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
        this.isEdit = !newValue;
      },
      immediate: true,
    },
  },
  mounted() {
    this.isScore =
      this.$store.state.role === "score-role" ||
      this.$store.state.role === "education-role" ||
      this.$store.state.role === "education-guide-role";
    if (!this.oldInfos?.id) {
      this.emptyText = "填写基本信息之后才能添加内容";
    }
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    this.addActivity();
  },
  methods: {
    showevidence(record) {
      this.title = "品牌活动";
      this.id = this.oldInfos.id;
      this.sj = record;
      this.showtable = true;
    },
    importsj() {
      this.$refs.dataImport.init("activity", this.oldInfos, "品牌活动");
    },
    addActivitys() {
      this.$refs.addActivity.init("add", this.oldInfos);
    },
    addActivity() {
      // this.pagination.current = 1;
      this.getData();
    },
    addActivitycz(sj) {
      console.log("🚀 ~ addActivitycz ~ sj:", sj);
      console.log(
        "🚀 ~ this.oldInfos.brandActivitylist ~ sj:",
        this.oldInfos.brandActivitylist
      );
      // this.pagination.current = 1;
      if (sj.type == "add") {
        // sj.record.id = sj.record.name + this.oldInfos.brandActivitylist.length;
        // this.oldInfos.brandActivitylist.push(sj.record);
        this.pagination.current = 1;
        this.oldInfos.brandActivitylist.unshift({
          ...sj.record,
          id: sj.record.name + (this.oldInfos.brandActivitylist.length + 1),
        });
      } else {
        let index = this.oldInfos.brandActivitylist.findIndex(
          (item) => item.id === sj.record.id
        );

        console.log("🚀 ~ addActivitycz ~ index:", index);
        if (index !== -1) {
          // 如果找到相同的 id，替换该对象
          //this.oldInfos.brandActivitylist[index] = sj.record;
          this.$set(this.oldInfos.brandActivitylist, index, sj.record);
        }
      }
      this.getData();
    },
    addActivity() {
      // this.pagination.current = 1;
      this.getData();
    },
    getData() {
      if (this.oldInfos?.id) {
        this.loading = true;
        let data = {
          applyType: 2,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxBase/lxApplyActivity/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = this.normalizeActivityList(data);
              this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        console.log(
          "🚀 ~ getData ~ this.oldInfos.brandActivitylist:",
          this.oldInfos
        );
        if (
          this.oldInfos &&
          this.oldInfos.brandActivitylist &&
          this.oldInfos.brandActivitylist.length > 0
        ) {
          this.pagination.total = this.oldInfos.brandActivitylist.length;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          let formatList = this.oldInfos.brandActivitylist.slice(
            startIndex,
            endIndex
          );
          if (formatList.length == 0 && this.pagination.current > 1) {
            this.pagination.current = this.pagination.current - 1;
            const startIndex =
              (this.pagination.current - 1) * this.pagination.pageSize;
            const endIndex = startIndex + this.pagination.pageSize;
            formatList = this.oldInfos.brandActivitylist.slice(
              startIndex,
              endIndex
            );
          }
          this.dataList = this.normalizeActivityList(formatList);
        } else {
          this.dataList = [];
          this.pagination.total = 0;
          this.pagination.current = 1;
        }
      }
    },
    /** 统一 holdTime / holdingTime / activityYear，保证表格「时间」列有值 */
    normalizeActivityList(list) {
      if (!Array.isArray(list)) return [];
      return list.map((item) => {
        const row = { ...item };
        let time = row.holdingTime || row.holdTime || "";
        if (!time && row.activityYear && String(row.activityYear).length === 4) {
          time = `${row.activityYear}-01-01`;
        }
        if (time) {
          row.holdingTime = time;
          row.holdTime = time;
          if (!row.activityYear && String(time).length >= 4) {
            row.activityYear = String(time).slice(0, 4);
          }
        }
        return row;
      });
    },
    handleOk() {
      console.log("🚀 ~ handleOk ~ this.deteleId:", this.deteleId);
      if (this.oldInfos?.id) {
        deleteAction("/lxBase/lxApplyActivity/delete", {
          id: this.deteleId,
          applyId: this.oldInfos?.id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.success("移除成功");
        this.showDeleteModel = false;
        this.oldInfos.brandActivitylist =
          this.oldInfos.brandActivitylist.filter(
            (item) => item.id != this.deteleId
          );
        sessionStorage.setItem("pp1", JSON.stringify(this.oldInfos));
        this.getData();
      }
    },
    deleteInfo(row, index) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row, index) {
      this.$refs.addActivity.init("edit", row, index);
    },
    seeInfo(row) {
      this.$refs.addActivity.init("see", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的品牌活动");
      } else {
        if (this.oldInfos?.id) {
          let params = {
            ids: this.selectedRowKeys.toString(),
            applyId: this.oldInfos?.id,
          };
          deleteAction("/lxBase/lxApplyActivity/deleteBatch", params).then(
            (res) => {
              if (res.code == 200) {
                this.$message.success("批量移除成功");
                // this.pagination.current = 1;
                this.getData();
                this.selectedRowKeys = [];
                this.$forceUpdate();
              } else {
                this.$message.error(res.message);
              }
            }
          );
        } else {
          // this.pagination.current = 1;
          // console.log(this.selectedRowKeys);
          this.oldInfos.brandActivitylist =
            this.oldInfos.brandActivitylist.filter(
              (item) => !this.selectedRowKeys.includes(item.id)
            );
          sessionStorage.setItem("pp1", JSON.stringify(this.oldInfos));
          this.getData();
          this.selectedRowKeys = [];
        }
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.cotainerhead {
  margin: 20px 0px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.btn-action {
    width: 100px;
    height: 30px;
    border-radius: 6px;
    font-weight: 400;
    cursor: pointer;
    line-height: 30px;
    margin-right: 10px;
    text-align: center;
}
.add-btn {
  width: 100px;
  height: 30px;
  background: #2155b5;
  border-radius: 6px;
  font-weight: 400;
  color: #fff;
  cursor: pointer;
  line-height: 30px;
  margin-right: 10px;
  text-align: center;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  color: #fff;
  background: #2155b5;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
}
.big-box {
  width: 253px;
  margin: 50px auto 0px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.table-content {
  margin: 0 auto;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}
.table-tr {
  width: 100%;
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  // border-bottom: 1px solid #e8e8e8;
}
/deep/.ant-table-tbody > tr > td:nth-child(5),
/deep/.ant-table-tbody > tr > td:nth-child(4) {
  padding: 0 !important;
  // overflow-wrap: break-word;
}
/deep/.ant-table-tbody > tr > td {
  padding: 0 !important;
  height: 60px;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>
